"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.animations = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _elements = require("../../styles/elements");

var _Announcement = require("./Announcement.styles");

var _icons = require("../../assets/icons");

var _AnimatePresenceMotion = _interopRequireDefault(require("./AnimatePresenceMotion"));

var _Modal = _interopRequireDefault(require("./Modal"));

var animations = {
  initial: {
    bottom: 0,
    translateY: '100%',
    opacity: 0,
    left: 0,
    zIndex: 1001,
    position: 'fixed'
  },
  end: {
    bottom: '12px',
    translateY: 0,
    opacity: 1
  }
};
exports.animations = animations;

var Announcement = function Announcement(_ref) {
  var className = _ref.className,
      onClose = _ref.onClose,
      children = _ref.children,
      tag = _ref.tag,
      title = _ref.title,
      copy = _ref.copy,
      footer = _ref.footer;
  return (0, _jsxRuntime.jsxs)("div", {
    css: _Announcement.styles.base,
    className: className,
    children: [(0, _jsxRuntime.jsx)("button", {
      className: "grui",
      type: "button",
      css: [_elements.button.styles.preflight, _Announcement.styles.closeBtn, process.env.NODE_ENV === "production" ? "" : ";label:Announcement;"],
      onClick: onClose,
      children: (0, _jsxRuntime.jsx)(_icons.Close, {})
    }), (0, _jsxRuntime.jsxs)("div", {
      css: _Announcement.styles.card,
      children: [children, (0, _jsxRuntime.jsxs)("div", {
        css: _Announcement.styles.content,
        children: [tag && (0, _jsxRuntime.jsx)("span", {
          css: _Announcement.styles.tag,
          children: tag
        }), title && (0, _jsxRuntime.jsx)("h4", {
          css: [_elements.heading.styles.h5, _Announcement.styles.heading, process.env.NODE_ENV === "production" ? "" : ";label:Announcement;"],
          children: title
        }), copy && (0, _jsxRuntime.jsx)("p", {
          className: "grui",
          css: _Announcement.styles.copy,
          children: copy
        })]
      }), footer]
    })]
  });
};

Announcement.propTypes = {
  className: _propTypes.string,
  onClose: _propTypes.func,
  children: _propTypes.node,
  tag: _propTypes.node,
  title: _propTypes.node,
  copy: _propTypes.node,
  footer: _propTypes.node
};
Announcement.defaultProps = {
  className: undefined,
  onClose: function onClose() {},
  children: function children() {},
  tag: undefined,
  title: undefined,
  copy: undefined,
  footer: undefined
};
Announcement.AnimatePresenceMotion = _AnimatePresenceMotion["default"];
Announcement.Modal = _Modal["default"];
var _default = Announcement;
exports["default"] = _default;
//# sourceMappingURL=Announcement.js.map